<template lang="pug">
  div
    .wuwow-card
      .wuwow-card-head
        h4.wuwow-card-title 新手上路
      .wuwow-card-body
        .row.justify-content-center
          .col-12.col-lg-4
            a.d-flex.flex-column.align-items-center.justify-content-center(href="javascript:;" @click="goToSelfTest")
              img(style="width: 250px" :src="require('@/assets/guide_self_test.svg')")
              span 自助系統測試
</template>
<script type="text/javascript">
export default {
  name: 'Guide',

  methods: {
    goToSelfTest() {
      this.$router.push('/dojo/account/selfTest');
    },
  },
};
</script>
